



























































































































































































































































































import _ from 'lodash';
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

import { Setting as terms } from '@/const/terms/mainTerms';
import { ComponentTerms as compTerms} from '@/const/terms/componentTerms';
import { EditCampaign as feedbackTerms } from '@/const/terms/feedback/campaign';

import { STATUS } from '@/const/status';
import { IAPP, ID_TYPE } from '@/const/types';
import { SubCategoryOptionType, FormResponse, FormType, ISubCategoryOption, IImpressionInterval, IBudget } from '@/pages/campaign/editingTypes';
import { InitialFormData } from '@/pages/campaign/editingData';
import { ElForm } from 'element-ui/types/form';

import Select from '@/components/ElementComponent/Select/index.vue';
import {SelectOptionType} from '@/components/ElementComponent/Select/types';
import NumberInput from '@/components/ElementComponent/Input/NumberInput.vue';
import PriceBrief from '@/components/ElementComponent/Brief/PriceBrief.vue';
import FormDateTimeRangePicker from '@/components/ElementComponent/Date/FormDateTimeRangePicker.vue';


@Component<CampaignFrom>({
    name: 'CampaignForm',
    components: {
        Select,
        NumberInput,
        PriceBrief,
        FormDateTimeRangePicker,
    },
})
export default class CampaignFrom extends Vue {
    @Prop({ type: Object, required: true }) private value!: FormType;

    @Prop({ type: Array, required: true }) private appOptions!: SelectOptionType<IAPP>[];
    @Prop({ type: Array, required: true }) private advertiserOptions!: SelectOptionType[];
    @Prop({ type: Array, required: true }) private countryOptions!: SelectOptionType[];
    @Prop({ type: Array, required: true }) private majorCategoryOptions!: SelectOptionType[];
    @Prop({ type: Array, required: true }) private subCategoryOptions!: SubCategoryOptionType[];

    @Prop({ type: Boolean, required: true }) private isEdit!: boolean;

    get subCategoryOptionsEachMajor() {
        return this.subCategoryOptions.filter((item: ISubCategoryOption) => item.divisionCode === this.form.category.major)
    }
    
    private compTerms = compTerms;
    
    private activeStatus: STATUS = STATUS.ACTIVE;
    private inactiveStatus: STATUS = STATUS.INACTIVE;
    
    get form() {return this.value}
    set form(v: FormType) {this.$emit('input', v)}
    private checkIsIntervalZero(rule: object, impInterval: IImpressionInterval, callback: any) {
        if (impInterval.isUsed) {
            if (impInterval.value) {
                callback();
                return true;
            }
        } else {
            callback();
            return true;
        }
        const r = rule as {message: string};
        callback(new Error(r.message));
        return false;
    }
    private checkIsBudgetZero(rule: object, value: IBudget, callback: any) {
        if (value.limited) {
            if (value.value > 0) {
                callback();
                return true;
            }
        } else {
            callback();
            return true;
        }
        const r = rule as {message: string};
        callback(new Error(r.message));
        return false;
    }
    private checkIsLimitedBudget(rule: object, value: boolean, callback: any) {
        if (value) {
            if (this.form.budget.limited) {
                callback();
                return true;
            }
        } else {
            callback();
            return true;
        }
        const r = rule as {message: string};
        callback(new Error(r.message));
        return false;
    }
    
}
